import { getCartItemCount } from '@/api/main/main';
import { getEstCartList } from '@/api/ggoods/estimate';
import sessionStore from '@/utils/sessionStore';

import store from '@/store';
import { DEFAULT_GRADE } from '@/views/ggoods/GgoodsDetail/constants';

import { goodsByGradeMapper } from '../../utils/mapper';

export default {
	state: {
		goodsNo: '', // 상품아이디
		cartItemCount: '', // 장바구니 개수
		cartEstimateItemCount: '', // 견적 담기 상품 개수
		/** 기존 구조상 api 결과 값을 직접 component에 전달 하고 싶을 때 사용 */
		goodsResponseData: {},

		/** 유효상품 */
		goodsOptions: [],
		goodsDetail: null,
	},
	mutations: {
		SET_GOODS_NO: (state, goodsNo) => {
			state.goodsNo = goodsNo;
		},
		SET_CART_ITEM_COUNT: (state, count) => {
			state.cartItemCount = count;
		},
		SET_ESTIMATE_CART_ITEM_COUNT: (state, count) => {
			state.cartEstimateItemCount = count;
		},
		SET_GOODS_RESPONSE_DATA: (state, data) => {
			state.goodsResponseData = data;
		},
		SET_GOODS_DETAIL: (state, payload) => {
			state.goodsDetail = payload;
		},
		// 회원혜택가
		SET_GOODS_OPTIONS: (state, data) => {
			// goodsStateCd === 'SUS' 는 판매중지로보인다
			// goodsEventDiscountRate < 있으면 이벤트 인것 가격은 등급마다 다똑같이 내려옴 ( 이벤트 가격 )

			state.goodsOptions = data;
			// @기존 소스
			// state.goodsOptions = state.goodsDetail.goodsDetail
			// 	.filter(e => e.goodsStateCd !== 'SUS')
			// 	.sort((a, b) => a.optionLevel - b.optionLevel);
		},
	},
	actions: {
		fetchGoodsDetail({ commit }, { goodsNo, detail }) {
			commit('SET_GOODS_NO', goodsNo);
			commit('SET_GOODS_DETAIL', detail);
		},
		fetchGoodsOptions({ commit }, result) {
			commit('SET_GOODS_OPTIONS', result.result);
		},
		SetGoodsNo({ commit }, goodsNo) {
			commit('SET_GOODS_NO', goodsNo);
		},
		SetCartItemCount({ commit }) {
			new Promise((resolve, reject) => {
				if (sessionStore.get('userNo') !== null) {
					getCartItemCount({})
						.then(response => {
							if (response.code === 'SUC0000') {
								resolve(response.result.totalCount);
							} else {
								console.error('[SetCartItemCount]', response);
								reject();
							}
						})
						.catch(error => {
							console.error('[SetCartItemCount]', error);
							reject();
						});
				} else {
					reject();
				}
			})
				.then(count => {
					commit('SET_CART_ITEM_COUNT', count);
				})
				.catch(() => {
					commit('SET_CART_ITEM_COUNT', 0);
				});
		},
		SetEstimateCartItemCount({ commit }) {
			new Promise((resolve, reject) => {
				if (sessionStore.get('userNo') !== null) {
					getEstCartList({})
						.then(response => {
							if (response.code === 'SUC0000') {
								resolve(response.result.totalCount);
							} else {
								console.error('[SetEstimateCartItemCount]', response);
								reject();
							}
						})
						.catch(error => {
							console.error('[SetEstimateCartItemCount]', error);
							reject();
						});
				} else {
					reject();
				}
			})
				.then(count => {
					commit('SET_ESTIMATE_CART_ITEM_COUNT', count);
				})
				.catch(() => {
					commit('SET_ESTIMATE_CART_ITEM_COUNT', 0);
				});
		},

		async updateCartItemCount({ commit, getters }) {
			console.log({ getters });
			if (!getters.isLoggedIn) return;

			try {
				const response = await getCartItemCount({});
				if (response.code !== 'SUC0000') throw new Error(`${response.code}: ${response.message}`);
				commit('SET_CART_ITEM_COUNT', response.result.totalCount);
			} catch (error) {
				console.error(error);
				commit('SET_CART_ITEM_COUNT', 0);
			}
		},
		setGoodsResponseData({ commit }, data = []) {
			commit('SET_GOODS_RESPONSE_DATA', data);
		},
	},
	getters: {
		cartItemCount: state => state.cartItemCount,
		goodsResponseData: state => state.goodsResponseData,
		goodsOptions: state => state.goodsOptions.price,
		crntGoodsOption: state => {
			if (state.goodsOptions.length <= 0) return false;
			return state.goodsOptions.price.find(e => String(e.goodsNo) === String(state.goodsNo));
		},
		/** 상세 데이터 : 현재 상품 기존 정보 + 선택된 상품옵션 정보 */
		crntGoods: (state, getters) => {
			const target = state.goodsDetail?.goodsDetail.find(e => String(e.goodsNo) === String(state.goodsNo));
			if (!target) return null;
			let grade = store.getters.userInfo.companyLevelCd?.toLowerCase() || DEFAULT_GRADE;
			const mapping = goodsByGradeMapper(grade, target);
			return { ...mapping };
		},
		ogGoodsDetail: state => state.goodsDetail,
	},
};
